import React from "react";

const SIZES={
  sm:{height:"var(--control-h-sm)",padding:"0 12px",fontSize:"var(--text-xs)",letterSpacing:"var(--tracking-wide)"},
  md:{height:"var(--control-h)",padding:"0 var(--control-pad-x)",fontSize:"var(--text-sm)",letterSpacing:"var(--tracking-wide)"},
  lg:{height:"var(--control-h-lg)",padding:"0 24px",fontSize:"var(--text-base)",letterSpacing:"0.01em"}
};

const VARIANTS={
  solid:{background:"var(--surface-brand)",color:"var(--fg-invert)",border:"1px solid var(--surface-brand)"},
  accent:{background:"var(--surface-accent)",color:"var(--teal-900)",border:"1px solid var(--surface-accent)"},
  outline:{background:"transparent",color:"var(--fg-1)",border:"1px solid var(--line-ink)"},
  subtle:{background:"var(--surface-brand-soft)",color:"var(--fg-brand)",border:"1px solid transparent"},
  ghost:{background:"transparent",color:"var(--fg-brand)",border:"1px solid transparent"},
  danger:{background:"var(--red-600)",color:"var(--fg-invert)",border:"1px solid var(--red-600)"}
};

const HOVER={
  solid:{background:"var(--teal-600)",borderColor:"var(--teal-600)"},
  accent:{background:"var(--cyan-400)",borderColor:"var(--cyan-400)"},
  outline:{background:"var(--surface-brand-soft)"},
  subtle:{background:"var(--teal-100)"},
  ghost:{background:"var(--surface-brand-soft)"},
  danger:{background:"#A3322B",borderColor:"#A3322B"}
};

export function Button({variant="solid",size="md",fullWidth=false,disabled=false,as="button",iconLeft,iconRight,children,style,...rest}){
  const [hover,setHover]=React.useState(false);
  const [press,setPress]=React.useState(false);
  const Tag=as;
  return (
    <Tag
      disabled={Tag==="button"?disabled:undefined}
      onMouseEnter={()=>setHover(true)}
      onMouseLeave={()=>{setHover(false);setPress(false)}}
      onMouseDown={()=>setPress(true)}
      onMouseUp={()=>setPress(false)}
      style={{
        display:"inline-flex",alignItems:"center",justifyContent:"center",gap:"8px",
        fontFamily:"var(--font-display)",fontWeight:"var(--weight-semibold)",
        borderRadius:"var(--radius-control)",cursor:disabled?"not-allowed":"pointer",
        textDecoration:"none",whiteSpace:"nowrap",width:fullWidth?"100%":"auto",
        transition:"var(--transition-control),transform var(--dur-instant) var(--ease-standard)",
        transform:press?"scale(var(--press-scale))":"none",
        opacity:disabled?0.42:1,
        ...SIZES[size],...VARIANTS[variant],
        ...(hover&&!disabled?HOVER[variant]:null),
        ...style
      }}
      {...rest}
    >
      {iconLeft}{children}{iconRight}
    </Tag>
  );
}
